import { styled, css, keyframes } from "styled-components";

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
`;

export const Section = styled.section`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme }) => theme.spacing.lg};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const MainContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};

  & > * {
    flex: 1 1 calc(50% - ${({ theme }) => theme.spacing.md});
  }

  @media (max-width: 768px) {
    & > * {
      flex: 1 1 100%;
    }
  }
`;

export const Wrapper = styled.div<{
  $fullWidth?: boolean;
  $halfWidth?: boolean;
  $isAligned?: boolean;
}>`
  align-self: normal;
  margin-bottom: ${({ theme }) => theme.spacing.md};

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      flex: 1 1 100%;
    `}

  ${({ $halfWidth }) =>
    $halfWidth &&
    css`
      @media (min-width: 768px) {
        width: calc(50% - ${({ theme }) => theme.spacing.sm});
      }
    `}

  ${({ $isAligned }) =>
    $isAligned &&
    css`
      align-self: flex-end;
    `}
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Label = styled.label`
  display: block;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  font-weight: bold;
  text-transform: capitalize;
`;

export const EditText = styled.textarea`
  width: 100%;
  height: 150px;
  padding: ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSizes.md};
  resize: none;
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  margin-right: ${({ theme }) => theme.spacing.xs};
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem; /* or your theme spacing */
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.error};
  font-size: 0.875rem;
  font-weight: bold;
  margin-top: ${({ theme }) => theme.spacing.xs};
`;
